import React, { useEffect, useState } from 'react';
import Select  from 'antd/lib/select';
import { useQuery } from 'react-query';
import {
  getBankAccountListByDirection,
  MgBankAccount
} from '../../services/parametersService';
import { isNil, noop } from 'lodash';
export type BankAccountSelectProps = any ;
// &
//   SelectProps<any> & {
//     mgid: number | any;
//     direction: any;
//     currcode: string | any;
//     strict?: boolean;
//     defaultSelect?: boolean;
//   };
const BankAccountSelect = ({
  mgid,
  direction,
  onChange = noop,
  value,
  currcode,
  defaultSelect,
  strict,
  ...props
}: BankAccountSelectProps) => {
  const { data } = useQuery(
    [
      'GetBankAccountListByDirectionParams',
      { mgid: mgid, direction: direction, currcode: currcode }
    ],
    () =>
      getBankAccountListByDirection({
        mgid: mgid,
        direction: direction,
        currcode: currcode,
        strict: strict ? false : true
      }).then((res) =>
        res.list?.length > 0
          ? res?.list?.filter((bk) => bk.bkstatus === 'VALID')
          : []
      )
  );
  const [defaultaccid, setdefaultaccid] = useState<number>();
  useEffect(() => {
    if (data && (isNil(value) || value === '') && !defaultSelect) {
      setdefaultaccid(data[0]?.accid);
      onChange(data[0]?.accid, null as any);
    }

    if ((data?.length === 0 || isNil(data)) && !defaultSelect) {
      setdefaultaccid(null as any);
      onChange(null as any, null as any);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <Select
      value={
        (isNil(value) || value === '') && !defaultSelect ? defaultaccid : value
      }
      allowClear
      onChange={onChange}
      {...props}
      onClear={() => {
        setdefaultaccid(undefined);
      }}
    >
      {data?.map((account: MgBankAccount) => (
        <Select.Option value={account.accid} key={account.accid}>
          {account.acclabel}
        </Select.Option>
      ))}
    </Select>
  );
};
export default BankAccountSelect;
